export const swedishTermsOfService = `
# Användarvillkor

Senast uppdaterad: 2025-11-10
Version: 2.1

Genom att använda taxiadministration.se accepterar du följande användarvillkor.

---

## 1. Tjänstebeskrivning

taxiadministration.se är ett SaaS-verktyg för löneberäkningar och administration för taxi- och transportföretag i Sverige. Tjänsten ägs och drivs av Baerell AB.

**Tjänsten erbjuder:**
- Automatiserade löneberäkningar från plattformsdata (Bolt, Uber, m.fl.)
- Export av löneunderlag och rapporter (PDF, Excel)
- Stöd för olika delningsmodeller och ersättningar

Vi strävar efter hög tillgänglighet men kan inte garantera oavbruten drift.

---

## 2. Behörighet

Du måste vara minst 18 år och ha rättslig behörighet att ingå bindande avtal. Om du använder tjänsten för ett företag garanterar du att du har behörighet att binda företaget.

---

## 3. Konto och Säkerhet

**Ditt ansvar:**
- Tillhandahålla korrekt information vid registrering
- Hålla inloggningsuppgifter konfidentiella
- Använda ett starkt och unikt lösenord
- Meddela oss omedelbart vid obehörig åtkomst

Vi förbehåller oss rätten att stänga av konton som bryter mot villkoren eller används för olagliga ändamål.

---

## 4. Betalning

- Tjänsten erbjuds via månatliga prenumerationer
- Betalning sker i förskott
- Vid utebliven betalning kan tjänsten begränsas
- Prisändringar meddelas minst 30 dagar i förväg
- Ingen återbetalning för outnyttjad tid

---

## 5. Användning

**Du får:**
- Beräkna löner för dina förare
- Hantera förardata och ekonomisk information
- Exportera rapporter och löneunderlag

**Du får INTE:**
- Dela ditt konto med andra
- Reverse-engineera tjänsten
- Använda tjänsten för olagliga ändamål
- Överföra skadlig kod
- Kringgå säkerhetsåtgärder

---

## 6. Immaterialrätt

taxiadministration.se och all relaterad mjukvara ägs av oss. Du får endast en begränsad rätt att använda tjänsten. Du behåller alla rättigheter till din data.

---

## 7. Ansvarsbegränsning

**Vi strävar efter att:**
- Tillhandahålla en säker och pålitlig tjänst
- Säkerställa noggrannhet i beräkningar

**Vi ansvarar INTE för:**
- Indirekta skador eller utebliven vinst
- Fel orsakade av felaktig inmatning
- Avbrott orsakade av force majeure

**Viktigt:** Du är ansvarig för riktigheten av data du lägger in. Kontrollera beräkningar innan användning för officiella ändamål. Konsultera revisor vid osäkerhet.

---

## 8. Uppsägning

**Från din sida:**
- Du kan när som helst avsluta prenumerationen
- Exportera din data före avslutning
- Din data raderas automatiskt 90 dagar efter avslutad prenumeration

**Från vår sida:**
- Vi kan avsluta vid väsentligt brott mot villkoren
- Vi kan avsluta vid utebliven betalning i mer än 14 dagar
- Du meddelas via email och får tid att exportera din data

---

## 9. Ändringar

Vi kan uppdatera dessa villkor. Väsentliga ändringar meddelas minst 30 dagar i förväg via email. Fortsatt användning innebär godkännande.

---

## 10. Kontakt

**Support och frågor:**
- Email: julius@baerell.com
- GDPR-ärenden: julius@baerell.com

---

**Genom att använda taxiadministration.se bekräftar du att du har läst, förstått och accepterat dessa användarvillkor.**

För information om hur vi hanterar dina personuppgifter, läs vår [Integritetspolicy](#).
`

export const termsVersion = "2.1"
export const termsLastUpdated = "2025-11-10"
